// Passport data layer — the single seam between the engine and the render tree.
//
// Given a wizard input (`{ wizard: { sliders, text } }`, the same shape the
// datasets store under `input`), it runs System 1 LIVE in the browser and hands
// the render sections a stable object. System 2 (quotes) needs the Haiku judge,
// which has no browser key — for dev we pass through a frozen `system2` snapshot
// from the dataset when present. Wizard-authored copy (stage names, dates, title)
// is not in the engine output; sections render those slots as placeholders until
// the wizard mapping-spec (Track B) lands.

import { detect } from '../insights/index.js';
import { deriveCarrierStages } from '../insights/carrierStages.js';
import { silhouetteOf } from './silhouette.js';

/**
 * @param {{ wizard: { sliders: any[], text?: any[] } }} input
 * @param {object|null} [frozenSystem2]  optional §VI/§VII snapshot (dev only)
 */
export function buildPassport(input, frozenSystem2 = null) {
  const sliders = input.wizard.sliders;
  const system1 = detect(sliders); // live — same output proven byte-equal to datasets
  // Carrier stages are a System-1 DERIVED field, not a detect() output (quote-spec §13:
  // "publishes indices OR a documented derivation"). Attached here rather than inside the
  // frozen detect() — the evidence line (§II/§IV/§V, wizard s5/s6, D&R s486.d1) must exist
  // offline too, where system2 is null and there are no quotes to reconstruct it from (s454).
  const { carrierStages, derivation } = deriveCarrierStages(system1, sliders);
  return {
    input,
    system1,
    carrierStages: { indices: carrierStages, derivation }, // same shape as the datasets' sibling
    system2: frozenSystem2, // null until a live judge or a frozen snapshot is supplied
    silhouette: silhouetteOf(sliders),
    stageCount: sliders.length,
  };
}
